const { MenuElements, getMenuElement } = require('SlotUI');
const PSEvents = require('PSEvents');
const PSState = require('PSState');
const SlotUI = require('SlotUI');
const GenericUI = require('GenericUI').ui;
const { GameStates } = require('ClientStates');

const State = cc.Enum({
    ACTIVE:  'ACTIVE',
    PASSIVE:  'PASSIVE',
});

cc.Class({
    extends: cc.Component,

    properties: {
        button: cc.Button,
        destoryOnDisable: true,
    },

    onLoad () {
        const data = getMenuElement(MenuElements.BuyFeature);
        const enabled = data.enabled && !data.emptyData;

        this.enabled = enabled;

        if (!this.button) {
            this.button = this.node.getComponent(cc.Button);
        }
        if (!this.button) {
            this.button = this.node.getComponentInChildren(cc.Button);
        }
        if (!this.button) {
            cc.warn('[BuyFeatureButton]: no button found');
            this.node.activate = false;
            return;
        }

        if (enabled && !SlotUI.isReplayMode()) {
            this.init();
        } else if (this.destoryOnDisable) {
            this.node.destroy();
        } else {
            this.node.active = false;
        }
    },

    init () {
        this.locked = false;
        this._deactivate();

        this._uiEnabledListener = () => this._onUiEnabled();
        this._spinRequestListener = () => this._deactivate();
        this._roundEndedListener = () => this._onRoundEnded();
        this._autoplayStarted = () => this.hide();
        this._autoplayEnded = () => this._onAutoplayEnded();
        this._gameResumeListener = () => this._onUiEnabled();

        PSEvents.subscribe(PSEvents.SPIN_REQUEST, this._spinRequestListener);
        PSEvents.subscribe(PSEvents.GAME_ROUND_ENDED, this._roundEndedListener);
        PSEvents.subscribe(PSEvents.AUTOPLAY_START, this._autoplayStarted);
        PSEvents.subscribe(PSEvents.AUTOPLAY_ENDED, this._autoplayEnded);
        PSEvents.subscribe(PSEvents.GAME_RESUMED, this._gameResumeListener);

        PSEvents.getLastOrSubscribe(PSEvents.UI_ENABLED, this._uiEnabledListener);
    },

    onDestroy () {
        PSEvents.unsubscribe(PSEvents.SPIN_REQUEST, this._spinRequestListener);
        PSEvents.unsubscribe(PSEvents.GAME_ROUND_ENDED, this._roundEndedListener);
        PSEvents.unsubscribe(PSEvents.AUTOPLAY_START, this._autoplayStarted);
        PSEvents.unsubscribe(PSEvents.AUTOPLAY_ENDED, this._autoplayEnded);
        PSEvents.unsubscribe(PSEvents.GAME_RESUMED, this._gameResumeListener);
    },

    _canBeActivated () {
        const isMain = PSState.gameState === GameStates.MAIN;
        const data = getMenuElement(MenuElements.BuyFeature);
        const enabled = data.enabled && !data.emptyData;

        return isMain && enabled && !SlotUI.isWinRestore() && !GenericUI.freeRoundFlag() && !SlotUI.isReplayMode();
    },

    _onUiEnabled() {
        if (GenericUI.freeRoundFlag() || GenericUI.isAutoplay()) {
            this.hide();
        } else {
            this.show();
            if (this._canBeActivated()) {
                this._activate();
            } else {
                this._deactivate();
            }
        }
    },

    _onRoundEnded () {
        if (GenericUI.freeRoundFlag() || GenericUI.isAutoplay()) {
            this.hide();
        } else {
            this.show();
            if (this._canBeActivated()) {
                this._activate();
            } else {
                this._deactivate();
            }
        }
    },

    _onAutoplayEnded () {
        if (!GenericUI.isGameRoundActive()) {
            this._onRoundEnded();
        }
    },

    _activate () {
        if (this.state === State.ACTIVE) {
            return;
        }
        this.state = State.ACTIVE;
        this.button.interactable = true;
        this._updateButtonState();
        this.node.emit('activated');
    },
    _deactivate () {
        if (this.state === State.PASSIVE) {
            return;
        }
        this.state = State.PASSIVE;
        this._updateButtonState();
        this.node.emit('deactivated');
    },

    _updateButtonState() {
        this.button.interactable = this.state === State.ACTIVE && !this.locked;
    },

    lock () {
        this.locked = true;
        this._updateButtonState();
    },

    unlock () {
        this.locked = false;
        this._updateButtonState();
    },

    hide () {
        if (this.enabled && this.node) {
            this.node.active = false;
        }
    },

    show () {
        if (this.enabled && this.node) {
            this.node.active = true;
        }
    },

    onClick () {
        if (this.enabled && this.node) {
            PSEvents.publish(PSEvents.BUY_BUTTON);
            this.node.emit('clicked');
        }
    }
});
